module.exports = __webpack_public_path__ + "img/pointer–blue.ffb3d231.svg";